<template>
    <div class="frame-group-container">
        <div class="frame-group-inner">
            <div class="frame-container frame-container-default">
                <div class="frame-inner">
                    <div class="row row-columns productsrow">
                        <FilterPanel :externalRegion="props.externalRegion" />
                        <Transition name="blend-in" mode="out-in">
                            <component :is="eventStore.activeComponent" :key="eventStore.activeComponent"
                                :externalRegion="props.externalRegion"></component>
                        </Transition>
                        <div class="programteaser" v-if="eventStore.activeComponent == List">
                            <p class="programteaser__title">
                                <strong>Wir beraten Sie gerne in allen Fragen!</strong><br>
                                Lesen Sie hier unsere <a href="https://ev-bildung.de/hilfe" class="underline">Tipps</a>
                                oder nehmen Sie <a href="https://ev-bildung.de/kontakt-anfahrt"
                                    class="underline">Kontakt</a> mit uns auf!
                            </p>
                            <a href="https://ev-bildung.de/jahresprogramme" class="programteaser__image"
                                title="Aktuelles Jahresprogramm herunterladen">
                                <span></span>
                            </a>
                            <a href="https://ev-bildung.de/jahresprogramme" class="programteaser__download">
                                <strong>Aktuelles Jahresprogramm</strong><br>
                                herunterladen
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import FilterPanel from './Partial Views/FilterPanel.vue'
import List from './Partial Views/List.vue'
import ContentSearchList from './Partial Views/ContentSearchList.vue';

import VueDatePicker from '/node_modules/@vuepic/vue-datepicker'
import("vue-multiselect/dist/vue-multiselect.min.css")

import { ref, computed, onMounted, shallowRef, watch, toRaw } from 'vue';

setTimeout(() => {
    import("@vuepic/vue-datepicker/dist/main.css");
}, 0)

const props = defineProps({
    externalCategory: String,
    externalRegion: String
})

onMounted(async () => {
    await eventStore.loadEvents();
    bookmarkStore.getBookmarksFromLocalStorage();

    //  data-region aus der webcomponent auslesen und Filter anwenden
    if (props.externalRegion) {
        let hasEvents = false;
        for (const region of eventStore.regions) {
            if (region.id == props.externalRegion) {
                eventStore.regionIdToFilter = { id: region.id, label: region.label };
                hasEvents = true;
            }
        }

        if (!hasEvents) {
            eventStore.regionIdToFilter = { id: props.externalRegion, label: undefined };
        }
    }

    // data-category aus der webcomponent auslesen und Filter anwenden
    if (props.externalCategory) eventStore.categoryIdsToFilter.push(props.externalCategory);
})

/*
*  Event-Store initialisieren
*/

import { createApp } from 'vue';
import { createPinia, defineStore } from 'pinia';
import bookmarkCount from '../../../ts/plugins/bookmark-count';

const useEventStore = defineStore('event', () => {
    const openFilter = ref(false);

    const activeComponent = shallowRef();

    const loading = ref(false);
    const searchLoading = ref(false);
    const urlStore = ref();

    const searchInput = ref("");
    const searched = ref(false);
    const searchedTerm = ref("");
    const resetInternalSearchInput = ref(false);
    const eventSearchMode = ref(true);

    const distanceLoading = ref(false);
    const distanceChanged = ref(false);

    const events = ref([]);
    const categories = ref([]);
    const topics = ref([]);
    const formats = ref([]);
    const regions = ref([]);

    const postcode_save = ref("");
    const distance_save = ref("");

    const searchIdsToFilter = ref([]);
    const contentSearchResults = ref([]);

    const categoryIdsToFilter = ref([]);
    const placeToFilter = ref("");
    const regionIdToFilter = ref(undefined);
    const dateToFilter = ref([]);
    const pricesToFilter = ref([]);
    const postcodeIdsToFilter = ref([]);

    const toggleComponent = (component) => {
        activeComponent.value = component;
        eventSearchMode.value = component === List;
        setUrlFilter();
    }

    const getPlaces = computed(() => {
        return [...new Set(events.value.map(event => event.place))].sort();
    });

    const getMaxPrice = computed(() => {
        return Math.max(...events.value.map(event => event.price));
    })


    const loadEvents = async () => {
        loading.value = true;

        const response = await fetch("/api/events.json");
        const loadedEvents = await response.json();
        events.value = [...loadedEvents];

        // const duplicateRegions = ref([]);
        const duplicateCategories = ref([]);

        loadedEvents.forEach(event => {
            // Categories befüllen
            Object.entries(event.categories).map(([key, value]) => duplicateCategories.value.push(({ id: key, label: value })))
            // Regions befüllen
            // if(event.regionId !== null) {
            //     duplicateRegions.value.push(({id: event.regionId, label: event.region}))
            // }
            // Places mit "Online" ersetzen
            if (event.isOnline) {
                event.place = "Online";
            }

        })

        categories.value = duplicateCategories.value
            .filter((value, index, self) =>
                index === self.findIndex((obj) =>
                    Object.keys(obj)[0] === Object.keys(value)[0] &&
                    Object.values(obj)[0] === Object.values(value)[0]
                )
            )
            .sort((a, b) => {
                const getNumericValue = (id) => {
                    // Seperators entfernen und erste 4 digits vergleichen. (Typen haben ID 999-1, 999-2, 999-3-1 etc. im Vergleich zu normalen Kategorien ID 1, 2, 3 etc.)
                    return Number.parseInt(id.replace(/-/g, '').slice(0, 4));
                };

                const valueA = getNumericValue(a.id);
                const valueB = getNumericValue(b.id);

                return valueA - valueB;
            });

        // regions.value = duplicateRegions.value.filter((value, index, self) =>
        //     index === self.findIndex((obj) => 
        //         Object.keys(obj)[0] === Object.keys(value)[0] && 
        //         Object.values(obj)[0] === Object.values(value)[0]
        //     )
        // );

        const formatIndex = categories.value.findIndex(item => String(item.id).startsWith("999"));
        topics.value = categories.value.slice(0, formatIndex);
        formats.value = categories.value.slice(formatIndex);

        loading.value = false;
    };

    const loadRegions = async () => {
        try {
            const response = await fetch("/api/events/regions.json");

            const data = await response.json();

            if (response.ok) {
                regions.value = [...data];
                regions.value.sort();
            } else {
                throw new Error(`Request failed: ${response.statusText}`)
            }
        } catch (err) {
            console.error(err);
        }
    }

    const loadDistanceFilter = async (postcode, distance) => {
        if (postcode) {
            let temp = postcode;
            temp = temp.replace(/\D/g, '');

            if (temp.length > 5) {
                temp = temp.slice(0, 5);
            }

            postcode = temp;
        }
        if (distance) distance = distance.replace(/\D/g, '');

        distanceLoading.value = true;

        if (postcode.length == 5 && distance) {
            const response = await fetch(`/api/events/postcode-radius-search.json?postcode=${postcode}&radius=${distance}`);
            const loadedPostcodes = await response.json();
            postcodeIdsToFilter.value = [...loadedPostcodes];
            distanceChanged.value = true;
        } else {
            distanceChanged.value = false;
        }

        postcode_save.value = postcode;
        distance_save.value = distance;

        distanceLoading.value = false;
    }

    const resetFilter = () => {
        categoryIdsToFilter.value = [];
        placeToFilter.value = "";
        regionIdToFilter.value = undefined;
        dateToFilter.value = [];
        pricesToFilter.value = [];
        postcodeIdsToFilter.value = [];
        distanceChanged.value = false;
        postcode_save.value = "";
        distance_save.value = "";
        searchInput.value = "";
        searchIdsToFilter.value = [];
        resetInternalSearchInput.value = !resetInternalSearchInput.value

        // URL Parameter löschen. Delay damit sie nicht sofort wieder ersetzt werden
        setTimeout(() => {
            urlStore.value = urlStore.value.split("?")[0];
            const resetUrl = new URL(urlStore.value);
            resetUrl.search = '';
            window.history.pushState({ path: resetUrl.href }, '', resetUrl.href);
        }, 1)
    };

    /*
    *   Events filtern
    */

    const filteredEvents = computed(() => {
        let filtered = events.value

        // Kategorie filtern
        if (categoryIdsToFilter.value.length > 0) {
            filtered = filtered.filter(event => {
                let isIncluded = false;
                for (const category of categoryIdsToFilter.value) {
                    if (Object.keys(event.categories).includes(category)) isIncluded = true;
                }
                return isIncluded;
            })
        }

        // Datum filtern
        if (Array.isArray(dateToFilter.value) && dateToFilter.value.length === 2) {
            const [start, end] = dateToFilter.value;
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            filtered = filtered.filter(event => {
                const compareStartDate = new Date(event.startDate);
                return (compareStartDate >= start && compareStartDate <= end);
            });
        }

        // Veranstaltungsort filtern
        if (placeToFilter.value) {
            filtered = filtered.filter(event => event.place === placeToFilter.value);
        }

        // Umkreis filtern
        if (distanceChanged.value) {
            filtered = filtered.filter(event => postcodeIdsToFilter.value.includes(Number.parseInt(event.id)));
        }

        // Regionalstelle filtern
        if (regionIdToFilter?.value && regionIdToFilter.value?.id) {
            filtered = filtered.filter(event => event.regionId === regionIdToFilter.value?.id);
        }

        // Preis filtern
        if (pricesToFilter.value[0] || pricesToFilter.value[1]) {
            filtered = filtered.filter(event => Number.parseInt(event.price) >= pricesToFilter.value[0] && Number.parseInt(event.price) <= pricesToFilter.value[1]);
        }

        // IDs aus der Suche filtern
        if (searchInput.value) {
            const searchIds = searchIdsToFilter.value.map(id => id.toString().trim());
            filtered = filtered.filter(event => searchIds.includes(event.id.toString().trim()));
        }

        setUrlFilter();

        return filtered;
    });

    /*
    *   Events filtern für die Anzeige der Anzahl pro Kategorie
    */

    const categoryEvents = computed(() => {
        let filtered = events.value

        // Datum filtern
        if (Array.isArray(dateToFilter.value) && dateToFilter.value.length === 2) {
            const [start, end] = dateToFilter.value;
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            filtered = filtered.filter(event => {
                const compareStartDate = new Date(event.startDate);
                return (compareStartDate >= start && compareStartDate <= end);
            });
        }

        // Veranstaltungsort filtern
        if (placeToFilter.value) {
            filtered = filtered.filter(event => event.place === placeToFilter.value);
        }

        // Umkreis filtern
        if (distanceChanged.value) {
            filtered = filtered.filter(event => postcodeIdsToFilter.value.includes(Number.parseInt(event.id)));
        }

        // Regionalstelle filtern
        if (regionIdToFilter?.value && regionIdToFilter.value?.id) {
            filtered = filtered.filter(event => event.regionId === regionIdToFilter.value?.id);
        }

        // Preis filtern
        if (pricesToFilter.value[0] || pricesToFilter.value[1]) {
            filtered = filtered.filter(event => Number.parseInt(event.price) >= pricesToFilter.value[0] && Number.parseInt(event.price) <= pricesToFilter.value[1]);
        }

        // IDs aus der Suche filtern
        if (searchInput.value) {
            const searchIds = searchIdsToFilter.value.map(id => id.toString().trim());
            filtered = filtered.filter(event => searchIds.includes(event.id.toString().trim()));
        }

        return filtered;
    });

    /*
    *   Filter in URL speichern
    */

    function setUrlFilter() {
        if (!urlStore.value) {
            urlStore.value = window.location.href;
        }
        const url = new URL(urlStore.value);
        const params = new URLSearchParams(url.search);

        params.set("eventFilter", 'BKh4AGK8A8ttX8mqv6cfew2dH');

        if (categoryIdsToFilter.value) {
            categoryIdsToFilter.value.length == 0 ? params.delete("category") :
                params.set("category", categoryIdsToFilter.value);
        }
        if (placeToFilter.value) {
            params.set("place", placeToFilter.value);
        }
        if (postcode_save.value) {
            params.set("postcode", postcode_save.value);
        }
        if (distance_save.value) {
            params.set("distance", distance_save.value);
        }
        if (regionIdToFilter.value?.id) {
            params.set("region", regionIdToFilter.value?.id);
        }
        if (pricesToFilter.value && pricesToFilter.value.length > 0) {
            params.set("price", pricesToFilter.value);
        }
        if (dateToFilter.value && dateToFilter.value.length > 0) {
            params.set("date", dateToFilter.value);
        }
        if (searchInput.value) {
            params.set("search", searchInput.value);
        }
        params.set("searchMode", eventSearchMode.value);


        url.search = params.toString();

        window.history.replaceState({ path: url.href }, '', url.href);
    }

    return {
        resetInternalSearchInput,
        openFilter,
        contentSearchResults,
        searchIdsToFilter,
        activeComponent,
        toggleComponent,
        searchLoading,
        eventSearchMode,
        searchInput,
        searched,
        loading,
        distanceLoading,
        events,
        categories,
        topics,
        formats,
        regions,
        searchedTerm,
        categoryIdsToFilter,
        placeToFilter,
        regionIdToFilter,
        dateToFilter,
        pricesToFilter,
        postcodeIdsToFilter,
        getPlaces,
        getMaxPrice,
        setUrlFilter,
        loadEvents,
        loadRegions,
        loadDistanceFilter,
        resetFilter,
        filteredEvents,
        categoryEvents
    };
});

/*
*  Bookmark-Store initialisieren
*/

const useBookmarkStore = defineStore("bookmark", () => {
    const eventStore = useEventStore();

    const bookmarks = ref([]);

    const getBookmarkedEvents = computed(() => {
        return eventStore.events.filter(event => {
            for (const bookmark of bookmarks.value) {
                if (event.id == bookmark) {
                    return true;
                }
            }
            return false;
        })
    })

    const getBookmarksFromLocalStorage = () => {
        if (localStorage.getItem("bookmarks")) {
            bookmarks.value = JSON.parse(localStorage.getItem("bookmarks"));
        }
    }

    const addBookmark = (id, startDate) => {
        bookmarks.value.push({ id: id, timestamp: Date.parse(startDate) });
        localStorage.setItem("bookmarks", JSON.stringify(bookmarks.value));

        bookmarkCount();
    }

    const removeBookmark = (id) => {
        const index = bookmarks.value.findIndex(item => item.id = id);
        bookmarks.value.splice(index, 1);
        localStorage.setItem("bookmarks", JSON.stringify(bookmarks.value));

        bookmarkCount();
    }



    return {
        bookmarks,
        getBookmarkedEvents,
        getBookmarksFromLocalStorage,
        addBookmark,
        removeBookmark
    }
})

const app = createApp({});
const pinia = createPinia();
app.component('VueDatePicker', VueDatePicker);
app.use(pinia);



const eventStore = useEventStore();
const bookmarkStore = useBookmarkStore();
</script>
